import "./frontend.scss";
import './js/skipLinkButton';
import './js/skipLinkText';